export default __webpack_public_path__ + "static/media/pobreza.198507f8.png";